"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSwapSportDto = instanceOfSwapSportDto;
exports.SwapSportDtoFromJSON = SwapSportDtoFromJSON;
exports.SwapSportDtoFromJSONTyped = SwapSportDtoFromJSONTyped;
exports.SwapSportDtoToJSON = SwapSportDtoToJSON;
exports.SwapSportDtoToJSONTyped = SwapSportDtoToJSONTyped;
/**
 * Check if a given object implements the SwapSportDto interface.
 */
function instanceOfSwapSportDto(value) {
    if (!('fromSportCode' in value) || value['fromSportCode'] === undefined)
        return false;
    if (!('toSportCode' in value) || value['toSportCode'] === undefined)
        return false;
    return true;
}
function SwapSportDtoFromJSON(json) {
    return SwapSportDtoFromJSONTyped(json, false);
}
function SwapSportDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fromSportCode': json['fromSportCode'],
        'toSportCode': json['toSportCode'],
    };
}
function SwapSportDtoToJSON(json) {
    return SwapSportDtoToJSONTyped(json, false);
}
function SwapSportDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'fromSportCode': value['fromSportCode'],
        'toSportCode': value['toSportCode'],
    };
}
